import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(private http: HttpClient) {}

  get(){
    return this.http.get(environment.apiUrl + 'news');
  }

  create(data: any) {
    return this.http.post(environment.apiUrl +  'admin/new/add', data);
  }

  update(id: number, data: any) {
    return this.http.post(environment.apiUrl +  'admin/new/update/' + id ,data);
  }

  delete(id: number) {
    return this.http.delete(environment.apiUrl +  `admin/new/destroy/${id}`);
  }
}
